<template>
  <div>
    <div v-if="showFormComponent">
      <Drawer
        class="ls_drawer_create_item"
        width="100%"
        v-model="showDrawer"
      >
        <catalogForm

          v-model="itemId"
          :base_view_url="base_view_url"
          :action="itemAction"
          :item_type="item_type"
          @click_cancel="cancelAction"
          @show_detail="showDetail"
          @reload_table="$emit('reload-table')"
        ></catalogForm>
      </Drawer>
    </div>


    <div v-if="showDetailComponent">
      <Drawer
        class="drawer_modal"
        v-model="showDrawer"
      >
        <catalogDetail

          :id="itemId"
          :base_view_url="base_view_url"
          :item_type="item_type"
          @data_loaded="onDataLoaded"
          @click_cancel="cancelAction"
          @click_edit="editAction"
          @reload_table="$emit('reload-table')"
        ></catalogDetail>
      </Drawer>
    </div>


  </div>

</template>

<script>
import { BaseItemData } from "../../base/base_item.js";

import catalogForm from "@/apps/catalog/catalogForm.vue";
import catalogDetail from "@/apps/catalog/catalogDetail.vue";

const TYPE_PRODUCT = "PRODUCT";
const TYPE_SERVICE = "SERVICE";
const TYPE_KIT = "KIT";

let _app = BaseItemData();
_app.components = {
  catalogDetail,
  catalogForm
};
_app.data = function() {
  return {
    titles: {
      detail: "Товар",
      edit: "Редактирование товара",
      create: "Создание товара"
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false,
    data: {
      type: TYPE_PRODUCT
    }
  };
};
_app.computed.title = function() {
  let title = "";
  if (this.data.type === TYPE_PRODUCT) {
    title = "Товар";
  } else if (this.data.type === TYPE_SERVICE) {
    title = "Услуга";
  } else if (this.data.type === TYPE_KIT) {
    title = "Комплект";
  }
  return title;
};

_app.methods.onDataLoaded = function(data) {
  this.data = data;
};
export default _app;
</script>

<style>
  /*.main-header.ivu-layout-header {*/
  /*  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);*/
  /*}*/
  .ls_drawer_create_item .ivu-drawer-close {
    display: none;

  }

  .ls_drawer_create_item .ivu-drawer-wrap, .ls_drawer_create_item  .ivu-drawer, .ls_drawer_create_item .ivu-drawer-mask {
    top: 108px;
    z-index: 98;
    height: calc(100% - 108px);
  }

  .ls_drawer_create_item  .ivu-drawer .ivu-drawer-body {
    padding: 0 40px 40px 40px;
  }

  .ls_drawer_create_item  .ivu-drawer-content {
    box-shadow: none;
  }
  @media screen and (max-width: 1900px) {
    .ls_drawer_create_item .ivu-drawer-wrap, .ls_drawer_create_item  .ivu-drawer, .ls_drawer_create_item .ivu-drawer-mask {
      top: 108px;
      height: calc(100% - 108px);
    }
  }

  @media screen and (max-width: 1500px) {
    .ls_drawer_create_item .ivu-drawer-wrap, .ls_drawer_create_item  .ivu-drawer, .ls_drawer_create_item .ivu-drawer-mask {
      top: 80px;
      height: calc(100% - 80px);
    }
  }


  @media screen and (max-width: 991px) {
    .ls_drawer_create_item  .ivu-drawer .ivu-drawer-body {
      padding: 0 20px 40px 20px;
    }
  }


  @media screen and (max-width: 575px) {
    .ls_drawer_create_item .ivu-drawer-wrap, .ls_drawer_create_item  .ivu-drawer, .ls_drawer_create_item .ivu-drawer-mask {
      top: 60px;
      height: calc(100% - 60px);
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/catalog/catalogItem.vue